import { useState, useEffect } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { Ucfirst } from '../../../utils/capitalization';
import { DateNowIsoString } from '../../../utils/date';
import { TemperatureToOneDecimal } from '../../../utils/conversion';
import Led from '../../../components/leds/Led';
import Select from '../../../components/select/Select';

export const HeatPumpTopic = {
    Receive: {
        Par_HP_Mode: "Par_HP_Mode",
        HPStatus: "HPStatus",
        TOU: "TOU",
        TOI: "TOI",
        HC3DT: "HC3DT",
        HePuDefrostSignal_2119: "HePuDefrostSignal_2119",
        HePuCompRunningSpeed_2104: "HePuCompRunningSpeed_2104"
    },
    Transmit: {
        Par_HP_Mode: "cmd/HeatPump/Par_HP_Mode",
        HePuDefrostSignal_2119: "cmd/HeatPump/HePuDefrostSignal_2119"
    }
}

const HeatPump = (props) => {
    const initialDevicesParam = {
        'ziggi': "Heat Pump",
            'data': [
                {'id': 1, 'name': "Operating Mode", 'key': "mode", 'val': 0, 'unit': ""},
                {'id': 2, 'name': "Status", 'key': "status", 'val': "n/a", 'unit': ""},
                {'id': 3, 'name': "Out T", 'key': "outTemperature", 'val': 0, 'unit': "°C"},
                {'id': 4, 'name': "Return T", 'key': "returnTemperature", 'val': 0, 'unit': "°C"},
                {'id': 5, 'name': "Desired T", 'key': "desiredTemperature", 'val': 0, 'unit': "°C"},
                {'id': 6, 'name': "Defrost", 'key': "defrost", 'val': false, 'unit': ""},
                {'id': 7, 'name': "Compressor Speed", 'key': "compressorSpeed", 'val': 0, 'unit': "Hz"}
            ]
    }

    const operationModeOptions = [
        { value: 0, label: "Off" },
        { value: 1, label: "Cooling" },
        { value: 2, label: "Heating" }
    ];

    const NAME = "Heat Pump";
    const NO_DEVICE_PARAMETERS = "No device parameters";
    const [devicesParam] = useState(initialDevicesParam)

    const HeatPumpStatusEnum = { 0: "Idle", 1: "Start", 2: "Run", 3: "Stop", 4: "Defr." }

    const [parHPMode, setParHPMode] = useState(devicesParam.data[0].val);
    const [parHPModeTime, setParHPModeTime] = useState("n/a");
    const [solarHPStatus, setHPStatus] = useState(devicesParam.data[1].val);
    const [solarHPStatusTime, setHPStatusTime] = useState("n/a");
    const [TOU, setTOU] = useState(TemperatureToOneDecimal(devicesParam.data[2].val));
    const [TOUTime, setTOUTime] = useState("n/a");
    const [TOI, setTOI] = useState(TemperatureToOneDecimal(devicesParam.data[3].val));
    const [TOITime, setTOITime] = useState("n/a");
    const [HC3DT, setHC3DT] = useState(devicesParam.data[4].val);
    const [HC3DTTime, setHC3DTTime] = useState("n/a");
    const [hePuDefrostSignal2119, setHePuDefrostSignal2119] = useState(devicesParam.data[5].val);
    const [hePuDefrostSignal2119Time, setHePuDefrostSignal2119Time] = useState("n/a");
    const [hePuCompRunningSpeed2104, setHePuCompRunningSpeed2104] = useState(devicesParam.data[6].val);
    const [hePuCompRunningSpeed2104Time, setHePuCompRunningSpeed2104Time] = useState("n/a");

    const onMessageReceive = (msg) => {
        var val = parseInt(msg.val);
        // console.log("RECIVE: "+msg.key+"="+msg.val)
        switch(msg.key) {
            case HeatPumpTopic.Receive.Par_HP_Mode:                 setParHPMode(val);                                  setParHPModeTime(DateNowIsoString); break;
            case HeatPumpTopic.Receive.HPStatus:                    setHPStatus(HeatPumpStatusEnum[val]);               setHPStatusTime(DateNowIsoString); break;
            case HeatPumpTopic.Receive.TOU:                         setTOU(TemperatureToOneDecimal(val));               setTOUTime(DateNowIsoString); break;
            case HeatPumpTopic.Receive.TOI:                         setTOI(TemperatureToOneDecimal(val));               setTOITime(DateNowIsoString); break;
            case HeatPumpTopic.Receive.HC3DT:                       setHC3DT(val);                                      setHC3DTTime(DateNowIsoString); break;
            case HeatPumpTopic.Receive.HePuDefrostSignal_2119:      setHePuDefrostSignal2119(val === 1 ? true : false); setHePuDefrostSignal2119Time(DateNowIsoString); break;
            case HeatPumpTopic.Receive.HePuCompRunningSpeed_2104:   setHePuCompRunningSpeed2104(val);                   setHePuCompRunningSpeed2104Time(DateNowIsoString); break;
            default:
                // console.log("Heat pump topic not found: " + msg.key);
                break;
        }
    }

    useEffect(() => {
        onMessageReceive(props.message);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const messageSend = (destination, message) => {
        props.onMessageSend(destination, message);
    }

    const onOperatingModeChange = (value) => {
        messageSend(HeatPumpTopic.Transmit.Par_HP_Mode, value)
        // setParHPMode(value)
        // setParHPModeTime(DateNowIsoString)
    }

    return devicesParam.data.length > 0 ? (
        <>
        <Row>
            <Col className="mb-2" xs={12} sm={12} md={12} lg={12} key="title">
                <h4 className="text-secondary">{Ucfirst(NAME)}</h4>
            </Col>
        </Row>
        <Row>
            <Col className="mb-2" xs={6} sm={4} md={4} lg={3} key={devicesParam.data[0].id}>
                <Card bg="dark" text="white" style={{fontSize: "0.75rem", textAlign: "center"}}>
                    <Card.Header style={{padding: "0.25rem"}}><b>{devicesParam.data[0].name}</b></Card.Header>
                    <Card.Body style={{padding: "0.25rem", fontSize: "2.5rem"}}>
                        <Card.Text style={{padding: "0.7rem"}}>
                            <Select value={parHPMode} onChange={onOperatingModeChange} options={operationModeOptions} />
                        </Card.Text>
                    </Card.Body>
                    <Card.Footer style={{padding: "0.25rem"}}>{parHPModeTime}</Card.Footer>
                </Card>
            </Col>
            <Col className="mb-2" xs={6} sm={4} md={4} lg={3} key={devicesParam.data[1].id}>
                <Card bg="dark" text="white" style={{fontSize: "0.75rem", textAlign: "center"}}>
                    <Card.Header style={{padding: "0.25rem"}}><b>{devicesParam.data[1].name}</b></Card.Header>
                    <Card.Body style={{padding: "0.62rem", fontSize: "2.0rem"}}>
                        <Card.Text style={{color: "bisque"}}>{solarHPStatus}</Card.Text>
                    </Card.Body>
                    <Card.Footer style={{padding: "0.25rem"}}>{solarHPStatusTime}</Card.Footer>
                </Card>
            </Col>
            <Col className="mb-2" xs={6} sm={4} md={4} lg={3} key={devicesParam.data[2].id}>
                <Card bg="dark" text="white" style={{fontSize: "0.75rem", textAlign: "center"}}>
                    <Card.Header style={{padding: "0.25rem"}}><b>{devicesParam.data[2].name}</b></Card.Header>
                    <Card.Body style={{padding: "0.25rem", fontSize: "2.5rem"}}>
                        <Card.Text style={{color: TOU > 50 ? "firebrick" : "cornflowerblue"}}>{TOU}<small>{devicesParam.data[2].unit}</small></Card.Text>
                    </Card.Body>
                    <Card.Footer style={{padding: "0.25rem"}}>{TOUTime}</Card.Footer>
                </Card>
            </Col>
            <Col className="mb-2" xs={6} sm={4} md={4} lg={3} key={devicesParam.data[3].id}>
                <Card bg="dark" text="white" style={{fontSize: "0.75rem", textAlign: "center"}}>
                    <Card.Header style={{padding: "0.25rem"}}><b>{devicesParam.data[3].name}</b></Card.Header>
                    <Card.Body style={{padding: "0.25rem", fontSize: "2.5rem"}}>
                        <Card.Text style={{color: TOI > 50 ? "firebrick" : "cornflowerblue"}}>{TOI}<small>{devicesParam.data[3].unit}</small></Card.Text>
                    </Card.Body>
                    <Card.Footer style={{padding: "0.25rem"}}>{TOITime}</Card.Footer>
                </Card>
            </Col>
            <Col className="mb-2" xs={6} sm={4} md={4} lg={3} key={devicesParam.data[4].id}>
                <Card bg="dark" text="white" style={{fontSize: "0.75rem", textAlign: "center"}}>
                    <Card.Header style={{padding: "0.25rem"}}><b>{devicesParam.data[4].name}</b></Card.Header>
                    <Card.Body style={{padding: "0.25rem", fontSize: "2.5rem"}}>
                        <Card.Text style={{color: HC3DT > 30 ? "firebrick" : "cornflowerblue"}}>{HC3DT}<small>{devicesParam.data[4].unit}</small></Card.Text>
                    </Card.Body>
                    <Card.Footer style={{padding: "0.25rem"}}>{HC3DTTime}</Card.Footer>
                </Card>
            </Col>
            <Col className="mb-2" xs={6} sm={4} md={4} lg={3} key={devicesParam.data[5].id}>
                <Card bg="dark" text="white" style={{fontSize: "0.75rem", textAlign: "center"}}>
                    <Card.Header style={{padding: "0.25rem"}}><b>{devicesParam.data[5].name}</b></Card.Header>
                    <Card.Body style={{padding: "1.125rem", fontSize: "2.5rem"}}>
                        <Led value={hePuDefrostSignal2119}/>
                    </Card.Body>
                    <Card.Footer style={{padding: "0.25rem"}}>{hePuDefrostSignal2119Time}</Card.Footer>
                </Card>
            </Col>
            <Col className="mb-2" xs={6} sm={4} md={4} lg={3} key={devicesParam.data[6].id}>
                <Card bg="dark" text="white" style={{fontSize: "0.75rem", textAlign: "center"}}>
                    <Card.Header style={{padding: "0.25rem"}}><b>{devicesParam.data[6].name}</b></Card.Header>
                    <Card.Body style={{padding: "0.25rem", fontSize: "2.5rem"}}>
                        <Card.Text style={{color: "mediumaquamarine"}}>{hePuCompRunningSpeed2104}<small>{devicesParam.data[6].unit}</small></Card.Text>
                    </Card.Body>
                    <Card.Footer style={{padding: "0.25rem"}}>{hePuCompRunningSpeed2104Time}</Card.Footer>
                </Card>
            </Col>
        </Row>
        </>
    ) : (
        <Row>
            <Col className="mb-2" xs={12} sm={12} md={12} lg={12}>
                <Card body bg="secondary" className="text-center">{NO_DEVICE_PARAMETERS}</Card>
            </Col>
        </Row>
    )
}

export default HeatPump